import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { CheckoutService } from "src/app/pages/customer-dashboard/services/checkout.service";
import * as moment from "moment";
import { StorageService } from "src/app/services/storage.service";
import { UserData } from "src/app/models/user-data.models";
import { MatDatepickerInput } from "@angular/material/datepicker";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { PaymentMethodsEnum } from "src/app/pages/customer-dashboard/enums/customer-dashboard.enum";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-common-summary-section",
  templateUrl: "./common-summary-section.component.html",
  styleUrls: ["./common-summary-section.component.scss"],
})
export class CommonSummarySectionComponent implements OnInit {
  userData!: UserData;
  disabledInitialPaymentField = true;
  constructor(
    public checkoutService: CheckoutService,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute
  ) {}

  panelOpenState: boolean = false;
  @Input() selectedPlanPrice: any;
  @Input() planForm!: FormGroup;
  @Input() escrowDetailsForm!: FormGroup;
  @Input() selectedOptionalCoverItems: any[] = [];
  @Input() selectedOptionalItemsPlanWise: any;
  @Input() selectedPeriodInitial = "/year";
  @Input() calculateOptionalItemValue: any;
  @Input() totalCostPrice: any;
  @Input() processingFee: any;
  @Input() subTotalPrice: any;
  @Input() effectiveTermDate: any;
  @Input() paymentMethod: any;
  @Input() showEscrowCard = false;
  @Input() escrowTotalCharged: any;
  @Input() totalSavings: any;
  @Input() coPayFee: any;
  @Input() isFromBilling = false;
  @Input() optionalPanelOpenState = false;
  @Input() subTotalWithDiscounts;
  @Input() isCoverageInfo;
  @Input() updateCoverageDetails;
  @Input() fieldConfiguration: any = {
    monthlyPayment: false,
    effectiveTerm: false,
    totalCharged: false,
    youSaved: false,
    stepNumber: 1,
  };
  @Input() loading = false;

  @Output() handleRemoveOptionalItems = new EventEmitter<any>();
  @Output() getPaymentType = new EventEmitter<boolean>();
  @Output() isInitialPaymentFieldDisabled = new EventEmitter<boolean>();
  today = new Date();
  minData!: any;
  @Input() installmentForm!: FormGroup;
  dates: string[] = [];
  isOnetimePayment = true;
  initialIntallmentPaymentPrice: any = 0;
  @Input() additionalDiscount: any;
  @Input() waitingPeriodForm!: FormGroup;
  @Input() installmentLimits!: number;
  @Input() salesTax = 0;
  ngUnsubscribe = new Subject<void>();
  public PaymentMethods = PaymentMethodsEnum;
  showInstallmentPaymentDate = false;
  firstInstallmentPrice: any;
  summaryType: any;
  daysOption = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
   @Input() customPriceForm !: FormGroup;
   @Input() isSuperAdmin = false;

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((res: any) => {
      this.summaryType = res?.params["update-coverage-info"] || null;
    });

    this.waitingPeriodForm
      .get("waitingPeriod")
      .setValue(this.waitingPeriodForm.get("waitingPeriod").value || 0);
    this.waitingPeriodForm.get("waitingPeriod")?.updateValueAndValidity();
    this.userData = this.storageService.getUser();
    this.minData = new Date().toISOString().slice(0, 10);
    if (this.installmentForm) {
      this.installmentForm
        .get("installmentType")
        .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: any) => {
          let inittalPaymentDate =
            this.installmentForm.get("installmentData")?.value;
            this.installmentChange(res);
          if (res && inittalPaymentDate) {
            this.generateDates(Number(res));
          }
        });
    }
    // this.forOneInstallmentPayment(this.subTotalWithDiscounts);
     this.customPriceValidator();
  }

  formatPriceInNumber(amount: number | string) {
    return Number((Math.round(Number(amount) * 100) / 100).toFixed(2));
  }

  handleDeleteOptionalItems(item: any) {
    this.handleRemoveOptionalItems.emit(item);
  }

  get installmentPayment() {
    let subTotal = 0;
   if(this.isSuperAdmin && this.customPriceForm.value?.isCustomPrice) {
     subTotal = this.customPriceForm.get("customPrice")?.value || 0;
   } else {
     if (this.isCoverageInfo) {
      this.showEscrowCard = false;
      subTotal = this.updateCoverageDetails?.extraCharge;
    } else {
      subTotal = this.subTotalWithDiscounts;
    }
   }

    let instalmentPrice = this.checkoutService.getInstallmentPaymentPrice(
      this.installmentForm,
      subTotal,
      this.showEscrowCard,
      this.escrowDetailsForm
    );
    return instalmentPrice;
  }

  get installmentMinDate() {
    let installmentData = this.installmentForm.get("initialPaymentData").value;
    let minDate = moment(installmentData)
      .add(1, "days")
      .toISOString()
      .split("T")[0];
    return minDate;
  }

  get isZeroAmount() {
    return this.updateCoverageDetails?.refundAmount === 0 && this.updateCoverageDetails?.extraCharge === 0;
  }
  

  generateDates(count: number): void {
    this.dates = [];
    let installmentPaymentDate =
      this.installmentForm.get("installmentData").value;
    for (let i = 0; i < count - 1; i++) {
      this.dates.push(
        moment(installmentPaymentDate).add(i, "months").format("MMMM DD, YYYY")
      );
    }
  }

  toggleInstallmentPayment(data: boolean) {
    this.isOnetimePayment = data;
    this.getPaymentType.emit(this.isOnetimePayment);
  }

  maxDate() {
    const currentDate = new Date();
    const afterDays = new Date();
    afterDays.setDate(currentDate.getDate() + 45);
    if (this.userData.isAdmin) {
      return null;
    }
    return afterDays.toISOString().split("T")[0];
  }

  datePickerhandleChange(event: MatDatepickerInput<any>) {
    if (event.value)
      this.generateDates(
        Number(this.installmentForm.get("installmentType").value)
      );
  }

 handleInitialPaymentChange() {
    if (this.disabledInitialPaymentField) {
      this.disabledInitialPaymentField = false;
    } else {
      if (this.isSuperAdmin && this.customPriceForm.value?.isCustomPrice) {
        if (
          this.initialIntallmentPaymentPrice <=
          (this.customPriceForm.get("customPrice")?.value || 0)
        ) {
          this.disabledInitialPaymentField = true;
          this.installmentForm.get("initialInstallmentPayment").setValue(this.initialIntallmentPaymentPrice);
        }
        this.isInitialPaymentFieldDisabled.emit(
          this.disabledInitialPaymentField
        );
        return;
      }
      if (this.showEscrowCard) {
        if (
          this.initialIntallmentPaymentPrice >
          (this.escrowDetailsForm.get("closingAmount")?.value || 0)
        ) {
        } else {
          this.disabledInitialPaymentField = true;
          this.installmentForm
            .get("initialInstallmentPayment")
            .setValue(this.initialIntallmentPaymentPrice);
        }
      } else {
        // For Crad and Bank Payment
        if (this.initialIntallmentPaymentPrice > this.subTotalWithDiscounts) {
          //show error message
        } else {
          this.disabledInitialPaymentField = true;
          this.installmentForm
            .get("initialInstallmentPayment")
            .setValue(this.initialIntallmentPaymentPrice);
        }
      }
    }
    this.isInitialPaymentFieldDisabled.emit(this.disabledInitialPaymentField);
  }

  repeatArray(count: number) {
    return Array(count).fill(0);
  }
  installmentText(index: number) {
    const textArray = [
      "",
      "One Payment",
      "Two Payments",
      "Three Payments",
      "Four Payments",
      "Five Payments",
      "Six Payments",
      "Seven Payments",
      "Eight Payments",
      "Nine Payments",
    ];
    if (index > 0 && index < 10) {
      return textArray[index];
    }
    return "";
  }
  get showInstalmentPart() {
    if (
      this.paymentMethod === PaymentMethodsEnum.card ||
      this.paymentMethod === PaymentMethodsEnum.bank
    ) {
      return true;
    } else if (
      this.paymentMethod === PaymentMethodsEnum.escrow &&
      this.showEscrowCard
    ) {
      return true;
    }
    return false;
  }
   get showInstallmentdate(): boolean {
    let isShow = false;
    const installmentData = this.installmentForm.get("installmentData");

    if(this.isSuperAdmin && this.customPriceForm.value?.isCustomPrice) {
      isShow = this.installmentForm.value?.initialInstallmentPayment <
        this.customPriceForm.get("customPrice")?.value
    } else {
      isShow = this.showEscrowCard
      ? this.installmentForm.value?.initialInstallmentPayment <
        this.escrowDetailsForm.get("closingAmount")?.value
      : this.installmentForm.value?.initialInstallmentPayment <
        this.subTotalWithDiscounts;
    }
    if (isShow && this.showInstallmentPaymentDate) {
      installmentData.setValidators([Validators.required]);
      installmentData.updateValueAndValidity();
    } else {
      installmentData.clearValidators();
      installmentData.updateValueAndValidity();
    }
    return isShow;
  }

  get onTimeInitialPayment() {
    if (
      this.paymentMethod === this.PaymentMethods.bank ||
      this.paymentMethod === this.PaymentMethods.card
    ) {
      if (this.isCoverageInfo) {
        this.firstInstallmentPrice = this.customPriceForm.value?.isCustomPrice ? (this.customPriceForm.value?.customPrice || 0) : this.updateCoverageDetails?.extraCharge;
      } else {
        this.firstInstallmentPrice = this.customPriceForm.value?.isCustomPrice ? (this.customPriceForm.value?.customPrice || 0) : this.subTotalWithDiscounts;
      }
    } else if (
      this.paymentMethod === this.PaymentMethods.escrow &&
      this.showEscrowCard
    ) {
      this.firstInstallmentPrice =
        this.escrowDetailsForm.get("closingAmount")?.value;
    }
    return "Initial Payment";
  }
   customPriceValidator() {
    const customPriceControl = this.customPriceForm.get("customPrice");
    this.customPriceForm
      .get("isCustomPrice")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: boolean) => {
        if (res) {
          customPriceControl.setValidators([
            Validators.required,
            Validators.min(1),
          ]);
          customPriceControl.updateValueAndValidity();
        } else {
          customPriceControl.clearValidators();
          customPriceControl.updateValueAndValidity();
        }
      });
  }
  installmentChange(res: any) {
    if (res === 1) {
      // this.forOneInstallmentPayment(this.subTotalWithDiscounts);
      this.showInstallmentPaymentDate = false;
      this.installmentForm.get("installmentData").setValue("");
      this.installmentForm.get("installmentData").updateValueAndValidity();
    } else {
      this.showInstallmentPaymentDate = true;
      let defaultInitialPayment: number;
      if(this.isCoverageInfo) {
        defaultInitialPayment = this.customPriceForm.value?.isCustomPrice
        ? Number(this.customPriceForm.value?.customPrice || 0) / res
        : Number(this.updateCoverageDetails?.extraCharge) / res;
      } else {
        defaultInitialPayment = this.customPriceForm.value?.isCustomPrice
        ? Number(this.customPriceForm.value?.customPrice || 0) / res
        : Number(this.subTotalWithDiscounts) / res;
      }

      this.installmentForm
        .get("initialInstallmentPayment")
        .setValue(defaultInitialPayment);
      this.initialIntallmentPaymentPrice = defaultInitialPayment;
      // this.forOneInstallmentPayment(0);
    }
  }
  handleIsCustomPriceChange(event: any) {
    this.installmentChange(this.installmentForm.get("installmentType").value);
  }
  handleCustomPriceChange(){
    this.installmentChange(this.installmentForm.get("installmentType").value);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
